<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      @dataAvailable="
        data => {
          deliveryLocations = data?.metaData?.locations || []
          isLoading = false
        }
      "
      contentId="deliveryLocations"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Zones de livraison</div>
      <div>
        <button
          v-if="deliveryLocations.length > 0"
          @click="addNewDeliveryLocation"
          class="buttonComponent"
        >
          &plus; Zone livraison
        </button>
      </div>
    </div>
    <div class="py-2"></div>

    <div class="relative" v-if="isLoading || deliveryLocations.length > 0">
      <div class="overflow-auto">
        <div>
          <div
            class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
          >
            <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
              Localisation
            </div>

            <div class="flex gap-6 w-[10rem] min-w-[10rem]">Date d'ajout</div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              Cout de livraison
            </div>
            <!-- <div class="flex gap-6 w-[10rem] min-w-[10rem]">En cours</div> -->
            <!-- <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              Dernière livraison
            </div> -->

            <div
              class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
            >
              Actions
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-4">
          <div
            v-for="(deliveryLocation, index) in isLoading
              ? shimmerdeliveryLocations
              : deliveryLocations"
            :key="index"
            :class="{ shimmerElement: deliveryLocation.shimmer }"
            class="flex items-center justify-between p-4 py-2 rounded-2xl gap-8 [&>div]:relative h-[4lh]"
          >
            <div
              class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
            ></div>
            <!-- Product Info -->
            <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
              <img
                :src="deliveryLocation.image"
                class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-xl"
              />
              <div class="w-[16rem]">
                <h3 class="font-semibold title-color truncate">
                  {{ deliveryLocation.countryName }}
                </h3>
                <p class="truncate text-sm">
                  {{ deliveryLocation.city }}
                </p>
                <!-- <p class="truncate text-sm">#{{ deliveryLocation.id }}</p> -->
              </div>
            </div>

            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{
                $Commons.timestampToDate(
                  deliveryLocation.createdAt,
                  'DD MMM YYYY',
                )
              }}
            </div>
            <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{
                $Commons.formatAmount(deliveryLocation.deliveryCost || 0)
              }}&nbsp;{{ deliveryLocation.currency }}
            </div>
            <!-- <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.formatAmount(deliveryLocation.pendingDelivery || 0) }}
            </div> -->
            <!-- <div class="flex gap-6 w-[10rem] min-w-[10rem]">
              {{ $Commons.timestampToDate(deliveryLocation.lastOrder, 'DD MMM YYYY') }}
            </div> -->

            <div
              class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
            >
              <DropdownComponent
                :selects="[
                  {
                    name: 'Changer le cout de livraison',
                    onClick() {
                      editDeliveryLocation(deliveryLocation)
                    },
                  },
                  {
                    name: 'Retirer',
                    onClick() {
                      deleteDeliveryLocation(deliveryLocation)
                    },
                  },
                ]"
                hideArrow
                maxHeight="270px"
                displayKey="name"
                toLeft
                :onSelect="
                  selected => {
                    selected.onClick()
                  }
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                  />
                </svg>
              </DropdownComponent>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/6">
        <img src="@/assets/images/empty/post-office.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">
          Aucune zone de livraison ajouté.
        </div>
        <div class="py-1"></div>
        <div class="text-lg">Vos zones de livraison s'afficheront ici</div>
        <div class="py-3"></div>
        <div class="flex justify-center gap-6">
          <button @click="addNewDeliveryLocation" class="buttonComponent">
            Ajouter une zone de livraison
          </button>
        </div>
      </div>
    </div>
    <EventListener
      :events="[
        'delivery_location_deleted',
        'failed_to_delete_delivery_location',
      ]"
      @delivery_location_deleted="onDeliveryLocationDeleted"
      @failed_to_delete_delivery_location="onDeliveryLocationDeletionFailed"
    />
    <NewDeliveryLocationAdding />
    <DeliveryLocationUpdater />
  </div>
</template>

<script>
import NewDeliveryLocationAdding from '@/components/deliveryLocations/NewDeliveryLocationAdding.vue'
import DeliveryLocationUpdater from '@/components/deliveryLocations/DeliveryLocationUpdater.vue'
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    EventListener,
    NewDeliveryLocationAdding,
    DeliveryLocationUpdater,
  },
  data() {
    return {
      eventsIds: [],
      deliveryLocations: [],
      activeTab: 'home',
      isLoading: true,
      shimmerdeliveryLocations: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {
    addNewDeliveryLocation() {
      this.$Events.dispatchEvent('delivery_location_creation_requested')
    },
    editDeliveryLocation(deliveryLocation) {
      this.$Events.dispatchEvent(
        'delivery_location_update_requested',
        deliveryLocation,
      )
    },
    async deleteDeliveryLocation(deliveryLocation) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez-vous vraiment retirer la zone: ${deliveryLocation.countryName} ${deliveryLocation.city} ?`,
          subTitle: 'Toutes les données concernant cette zone seront effacé',

          successText: 'Supprimer La zone de livraison',
          cancelText: 'Conserver La zone de livraison',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('delivery_location_deletion_requested', {
        id: deliveryLocation.id,
      })
    },
    onDeliveryLocationDeleted() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Réussi',
        body: 'La zone de livraison a été supprimé avec succès',
      })
    },
    onDeliveryLocationDeletionFailed(response) {
      let message = 'Echec lors de la supression de la zone de livraison'
      if (response.deliveryLocationNotFound)
        message = 'Cette zone de livraison est déjà supprimée'
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Echoué',
        body: message,
      })
    },
  },
}
</script>
